/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
export type CanBeEdited_ItemFragment = { __typename: 'Item', id: string, isItemEliminated: boolean, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', reason: string } | null };

export type AllowHaveChildren_ItemFragment = { __typename: 'Item', id: string, isItemEliminated: boolean, decisionOptionElimination?: { __typename: 'DecisionOptionElimination', reason: string } | null };

export const CanBeEdited_ItemFragmentDoc = gql`
    fragment CanBeEdited_Item on Item {
  id
  isItemEliminated
  decisionOptionElimination {
    reason
  }
}
    `;
export const AllowHaveChildren_ItemFragmentDoc = gql`
    fragment AllowHaveChildren_Item on Item {
  id
  isItemEliminated
  decisionOptionElimination {
    reason
  }
}
    `;